'use client';

import { cn } from '@/utils';
import { DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';

type Props = {} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

/**
 * NOTE:
 * Overlay has a z-index of 1 by default.
 * By default, the overlay is hidden behind the clipPath.
 * To open, set it to clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'.
 */
const Overlay = forwardRef<HTMLDivElement, Props>(({ children, className, ...props }, ref) => {
  return (
    <div className={cn(`fixed top-0 left-0 z-1 w-dvw h-dvh flex`, className)} ref={ref} {...props}>
      {children}
    </div>
  );
});

Overlay.displayName = 'Overlay';

export default Overlay;
